module.exports = "https://static.energy5.com/_next/static/images/ledBg-63883472b335f3397f9a2dea4d7719a9.webp";